(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1854],{

/***/ 96545:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/register",
      function () {
        return __webpack_require__(76473);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Register; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _templates_account__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11292);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42310);




var RegisterTemplate = _templates_account__WEBPACK_IMPORTED_MODULE_2__/* ["default"].register */ .Z.register;
var authOptions = {
    autoRedirect: true,
    defaultRoute: "/account/orders",
    id: "withRegister"
};
var __N_SSG = true;
function Register(param) {
    var initialSettings = param.settings;
    var liveSettings = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__.useSettings)();
    var settings = liveSettings || initialSettings;
    // will redirect to account if signed in
    var authenticated = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__.useCustomerAuth)(authOptions).authenticated;
    return authenticated === false ? RegisterTemplate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RegisterTemplate, {
        action: "register",
        settings: settings
    }) : "Register template not provided" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .AccountsAuthLoader */ .iT, {}) // while you are auto redirect
    ;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9349,1292,9774,2888,179], function() { return __webpack_exec__(96545); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);